import React from 'react'
import PropTypes from 'prop-types'

import { BRA, COL, CRI, USA, ECU } from 'commons/js/country'
import { RenderSwitch } from '@elparking/components'

const isBrazil = ({ country }) => country === BRA
const isColombia = ({ country }) => country === COL
const isCostaRica = ({ country }) => country === CRI
const isEcuador = ({ country }) => country === ECU
const isUSA = ({ country }) => country === USA

function CountrySwitch ({ bra, col, cri, esp, usa, ecu, ...restProps }) {
    return (
        <RenderSwitch
          {...restProps}
          bra={bra}
          col={col}
          cri={cri}
          usa={usa}
          ecu={ecu}
          defaultComponent={esp}
          test={() => ({
              bra: isBrazil(restProps),
              col: isColombia(restProps),
              cri: isCostaRica(restProps),
              usa: isUSA(restProps),
              ecu: isEcuador(restProps),
          })}
        />
    )
}

CountrySwitch.propTypes = {
    bra: PropTypes.func,
    col: PropTypes.func,
    cri: PropTypes.func,
    esp: PropTypes.func,
    usa: PropTypes.func,
    ecu: PropTypes.func,
    country: PropTypes.string,
}

export default CountrySwitch
